import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { TEXT } from '../../config/constants';
import Button from '../Button';
import css from './EmailCaptureName.module.scss';
import validEmail from '../../utils/strings/validEmail';
import withNewsletter from '../withNewsletter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var TextInput = function TextInput(_ref) {
  var className = _ref.className,
      inputType = _ref.inputType,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      value = _ref.value;
  return /*#__PURE__*/_jsxs("label", {
    className: className,
    htmlFor: name,
    children: [/*#__PURE__*/_jsx("div", {
      className: css.label,
      children: label
    }), /*#__PURE__*/_jsx("input", {
      className: css.input,
      onChange: onChange,
      required: true,
      type: inputType,
      name: name,
      id: name,
      value: value,
      placeholder: placeholder
    })]
  });
};

TextInput.propTypes = {
  className: PropTypes.string,
  inputType: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};
TextInput.defaultProps = {
  className: '',
  inputType: false
};
export var EmailCaptureNameForm = /*#__PURE__*/function (_Component) {
  _inherits(EmailCaptureNameForm, _Component);

  var _super = _createSuper(EmailCaptureNameForm);

  function EmailCaptureNameForm(props) {
    var _this;

    _classCallCheck(this, EmailCaptureNameForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChangeName", function (e) {
      var target = e.target;
      var value = target.value;
      var id = target.id;

      _this.setState(_defineProperty({}, id, value));
    });

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (event) {
      var _this$props = _this.props,
          email = _this$props.email,
          listId = _this$props.listId,
          source = _this$props.source,
          submit = _this$props.submit,
          utmCampaign = _this$props.utmCampaign,
          utmMedium = _this$props.utmMedium,
          utmSource = _this$props.utmSource;
      var _this$state = _this.state,
          first = _this$state.first,
          last = _this$state.last;

      if (event !== undefined) {
        event.preventDefault();
      }

      var body = {
        email: email,
        first_name: first,
        last_name: last,
        source: source,
        utm_campaign: utmCampaign,
        utm_medium: utmMedium,
        utm_source: utmSource
      };

      if (listId) {
        body.klaviyo_list_id = listId;
      }

      window.optimizely = window.optimizely || [];
      window.optimizely.push({
        type: 'event',
        eventName: 'EmailCaptureSubmit'
      });
      submit(body);
    });

    _defineProperty(_assertThisInitialized(_this), "validate", function () {
      var email = _this.props.email;
      return validEmail(email);
    });

    var CUSTOMER = window.OV.CUSTOMER;
    var loggedIn = CUSTOMER.loggedIn,
        name = CUSTOMER.name;
    var _first = '';
    var _last = '';

    if (loggedIn && name) {
      var names = name.split(' ');
      _first = names.length >= 1 ? names[0] : _first;
      _last = names.length >= 1 ? names[1] : _last;
    }

    _this.state = {
      first: _first,
      last: _last
    };
    return _this;
  }

  _createClass(EmailCaptureNameForm, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          email = _this$props2.email,
          error = _this$props2.error,
          fetching = _this$props2.fetching,
          loaded = _this$props2.loaded,
          light = _this$props2.light,
          onEmailEnter = _this$props2.onEmailEnter;
      var _this$state2 = this.state,
          first = _this$state2.first,
          last = _this$state2.last;
      var emailCapture = TEXT.emailCapture;
      var success = !error && loaded;
      var contentClass = cc([css.content, _defineProperty({}, css.hide, success)]);
      var successClass = cc([css.success, _defineProperty({}, css.show, success)]);
      var buttonClass = cc([css.button, _defineProperty({}, css.hide, success)]);
      var valid = this.validate();
      return /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsxs("form", {
          className: cc([css.form, _defineProperty({}, css.light, light)]),
          onSubmit: valid ? this.onSubmit : function () {},
          children: [/*#__PURE__*/_jsxs("div", {
            className: contentClass,
            children: [/*#__PURE__*/_jsx("h2", {
              className: css.title,
              children: "OVU Crew"
            }), /*#__PURE__*/_jsxs("p", {
              className: css.text,
              children: ["Like #DoingThings On Campus? (We had a hunch.)", /*#__PURE__*/_jsx("br", {}), "Apply to be an OVU Crew Member and help rep OV at your university through events, social posts and more."]
            }), /*#__PURE__*/_jsxs("div", {
              className: css.labels,
              children: [/*#__PURE__*/_jsxs("div", {
                className: css.nameInputs,
                children: [/*#__PURE__*/_jsx(TextInput, {
                  className: css.nameInput,
                  inputType: "text",
                  label: "First",
                  name: "first",
                  onChange: this.onChangeName,
                  placeholder: "Jane",
                  value: first
                }), /*#__PURE__*/_jsx(TextInput, {
                  className: css.nameInput,
                  inputType: "text",
                  label: "Last",
                  name: "last",
                  onChange: this.onChangeName,
                  placeholder: "Doe",
                  value: last
                })]
              }), /*#__PURE__*/_jsx(TextInput, {
                inputType: "email",
                label: "Email",
                name: "email",
                onChange: onEmailEnter,
                placeholder: "jill@mail.com",
                value: email
              })]
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: buttonClass,
            children: /*#__PURE__*/_jsx(Button, {
              "aria-busy": fetching,
              big: true,
              disabled: fetching,
              borderedHover: light,
              type: "submit",
              children: /*#__PURE__*/_jsx("span", {
                children: "Get The Application"
              })
            })
          }), /*#__PURE__*/_jsxs("div", {
            "aria-hidden": success ? undefined : true,
            className: successClass,
            children: [/*#__PURE__*/_jsx("h2", {
              "aria-hidden": success ? undefined : true,
              className: css.title,
              children: emailCapture.success.title
            }), /*#__PURE__*/_jsx("p", {
              className: css.text,
              role: "status",
              children: success ? emailCapture.success.text : ''
            })]
          }), error && /*#__PURE__*/_jsx("p", {
            className: cc([css.copy, css.error]),
            role: "status",
            children: emailCapture.errors.email
          })]
        })
      });
    }
  }]);

  return EmailCaptureNameForm;
}(Component);
EmailCaptureNameForm.defaultProps = {
  light: false,
  listId: false,
  utmCampaign: '',
  utmMedium: '',
  utmSource: ''
};
EmailCaptureNameForm.propTypes = {
  email: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  light: PropTypes.bool,
  listId: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  fetching: PropTypes.bool.isRequired,
  loaded: PropTypes.bool.isRequired,
  onEmailEnter: PropTypes.func.isRequired,
  source: PropTypes.string.isRequired,
  submit: PropTypes.func.isRequired,
  utmCampaign: PropTypes.string,
  utmMedium: PropTypes.string,
  utmSource: PropTypes.string
};
export default withNewsletter(EmailCaptureNameForm);